import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect, Link } from 'react-router-dom';
import { renderToStaticMarkup } from 'react-dom/server';

import { storageKeys } from 'config/settings.json';
import LanguageSelect from 'components/LanguageSelect';
import SweetAlert from 'components/SweetAlert';
import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import { toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import InputField from 'components/LoginForm/Input';
import SellingPoints from 'components/SellingPoints';
import { performLogin } from 'helpers/performLogin';
import { useSettings } from 'hooks/useSettings';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const NoAgentScreen = ({ clientName, clientWebsite }) => {
  return (
    <div className="noAgent__container">
      <h5>
        {i18n.translate('loginScreen.noAgent.title', {
          clientName,
        })}
      </h5>
      <p>
        {i18n.translate('loginScreen.noAgent.messageWeb', {
          clientName,
        })}
      </p>
      <p>
        <a href={clientWebsite}>{clientWebsite}</a>
      </p>
      <a href={clientWebsite}>
        <button>{i18n.translate('loginScreen.noAgent.visitWebsite')}</button>
      </a>
    </div>
  );
};

class EmailInner extends Component {
  constructor() {
    super();
    this.state = {
      noAgent: false,
      redirect: '',
      errorMessage: '',
      clientName: '',
      companyWebsite: '',
      clientWebsite: '',
      clientId: '',
      clientSecret: '',
      appName: '',
      latestCheckedEmail: '',
      featureFlags: [],
      ambassador: false,
      loginMessages: [],
    };

    this.handleCheckEmail = this.handleCheckEmail.bind(this);
    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
  }

  componentDidMount() {
    this.getAppInfo();
  }

  getAppInfo() {
    StorageHandler.load(storageKeys.appInfo).then(async (appInfo) => {
      if (appInfo) {
        const { clientId, clientSecret, companyWebsite, clientName, clientWebsite, appName, featureFlags, appId } =
          appInfo;

        const { is_enabled: isAmbassadorEnabled = false } =
          featureFlags.find((f) => {
            return f.name === 'ambassador';
          }) ?? {};

        this.setState({
          clientId,
          clientSecret,
          companyWebsite,
          clientName,
          clientWebsite,
          appName,
          featureFlags,
          ambassador: isAmbassadorEnabled,
        });
        const messageAppId = this.props.salesCompanionAppId || appId;
        if (messageAppId) {
          const res = await APIHandler.getLoginMessages(messageAppId);
          const loginMessages = Array.isArray(res) ? res : [];
          this.setState({ loginMessages });
        }
      }
    });
  }

  async handleCheckEmail(event) {
    event.preventDefault();

    const { setAnim, userInput, userExistsHandler } = this.props;
    const { email } = userInput;
    const { clientId } = this.state;
    const submit = event.target;
    submit.disabled = true;
    setAnim('loadingAnim', true);
    if (!email) {
      toast.error(`${i18n.translate('loginScreen.version2.errors.fillInEmail')}`, {
        position: toast.POSITION.TOP_CENTER,
      });
      setAnim('loadingAnim', false);
      submit.disabled = false;
    }
    await APIHandler.checkEmail(email, clientId).then((res) => {
      userExistsHandler(res.success);
      this.setState({ errorMessage: res.message, latestCheckedEmail: email });
      setAnim('loadingAnim', false);
      submit.disabled = false;
    });
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) StorageHandler.save(storageKeys.user, userInfo, 2592000000);
    document.body.classList.remove('no-scroll');
    this.setState({ redirect: customRedir || '/main' });
  }

  async loginHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();

    const { setAnim, userInput } = this.props;
    const { email, password } = userInput;
    const { clientId, clientSecret } = this.state;

    const userExists = await StorageHandler.exists(storageKeys.user);
    if (!userExists) {
      setAnim('loadingAnim', true);

      try {
        const result = await performLogin(email, password, clientId, clientSecret);

        if (!result.success) {
          submit.disabled = false;
          toast.error(result.message ?? '', {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setAnim('loadingAnim', false);
          return;
        }

        if (result.redirectToQuickRegister) {
          window.location.replace('/login/quick-register');
          return;
        }

        this.login(result.user, true);
      } catch (error) {
        toast.error(error.message ?? 'Login failed. Please try signing in on the login page.', {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      return;
    }

    StorageHandler.load(storageKeys.user).then((userInfo) => {
      // Loads userInfo from localStorage
      submit.disabled = false;
      this.login(userInfo, false);
    });
  }

  render() {
    const {
      noAgent,
      redirect,
      errorMessage,
      clientName,
      companyWebsite,
      appName,
      clientWebsite,
      latestCheckedEmail,
      // featureFlags,
      ambassador,
      loginMessages,
    } = this.state;
    const { change, loadingAnim, userExists, userInput } = this.props;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    // const close2 = (type) => {
    //   if (type.dismiss !== 'cancel') {
    //     window.location.replace('https://mp.weixin.qq.com/s/OLEdCWjtUmrasf3AIM8GIw');
    //   }
    // };

    let buttonText = i18n.translate('loginScreen.version2.continueButton');
    let buttonFunction = this.handleCheckEmail;

    let errorCopy = '';
    if (userExists === true) {
      errorCopy = errorMessage;
      buttonText = i18n.translate('loginScreen.version2.loginButton');
      buttonFunction = this.loginHandler;
    }
    if (userExists === false) {
      buttonText = i18n.translate('loginScreen.version2.otherEmailButton');
      buttonFunction = this.handleCheckEmail;
    }

    return (
      <div className="Email">
        <SweetAlert
          trigger={noAgent}
          {...{
            title: '',
            show: noAgent,
            html: renderToStaticMarkup(
              <NoAgentScreen
                clientName={clientName}
                companyWebsite={companyWebsite}
                clientWebsite={clientWebsite}
                close={close}
              />,
            ),
            customClass: 'noAgent',
            showConfirmButton: false,
            cancelButtonText: i18n.translate('general.close'),
            showCancelButton: true,
            onConfirm: close,
            onCancel: close,
            onEscapeKey: close,
            onOutsideClick: close,
            onClose: () => {
              close();
            },
          }}
        />
        <h3 className="global__text--title">{i18n.translate('loginScreen.welcome.headerTop')}</h3>
        <h3 className="global__text--title">{appName}</h3>
        <SellingPoints />
        {loginMessages.map(({ id, message, weblink }) => {
          const html = (message || '').replaceAll('<p><br></p>', '');

          if (weblink) {
            const iframeSrc = weblink.includes('http')
              ? weblink
              : `${window.location.origin}${weblink.startsWith('/') ? '' : '/'}${weblink}`;
            return (
              <div key={id} className="Email__message">
                <a
                  className="Email__message--weblink"
                  data-fancybox={id}
                  data-type="iframe"
                  data-src={iframeSrc}
                  href={iframeSrc}
                >
                  <div className="Email__message--text" dangerouslySetInnerHTML={{ __html: html }} />
                </a>
              </div>
            );
          }

          return (
            <div key={id} className="Email__message">
              <div className="Email__message--text" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          );
        })}
        <div className="Email__input">
          <LanguageSelect />
          <div className="Email__input--wrapper">
            <div className="inputFields">
              <b>{i18n.translate('loginScreen.version2.homeTitle')}</b>
              <br />
              <br />
              <legend>{i18n.translate('loginScreen.version2.homeTitleSub')}</legend>
              {userExists && (
                <legend>
                  {!errorCopy.includes('An account has been created') && (
                    <p className="warning">{i18n.translate('loginScreen.version2.matchFound')}</p>
                  )}
                  {errorCopy.includes('An account has been created') && <p className="warning">{errorCopy}</p>}
                </legend>
              )}
              <InputField
                defaultVal={userExists !== false ? userInput.email : ''}
                change={change}
                fieldType="email"
                fieldName="email"
                fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
                icon="envelope"
                line
                key={userExists}
              />
              {userExists && (
                <InputField
                  change={change}
                  fieldType="password"
                  fieldName="password"
                  fieldPlaceholder={i18n.translate('loginScreen.version2.fields.password')}
                  icon="key"
                  autocomplete="password"
                  line
                />
              )}
              {userExists === false && (
                <p className="warning">
                  {i18n.translate('loginScreen.version2.noAccount', {
                    email: latestCheckedEmail,
                  })}
                </p>
              )}
            </div>
          </div>

          <div className="login__form--buttons">
            <div className="Email__input--holder">
              {!ambassador && (
                <button
                  type="button"
                  className="loginView__content--request noAgentBtn"
                  onClick={() => {
                    return this.setState({ noAgent: true });
                  }}
                >
                  {i18n.translate('loginScreen.noAgent.noAgentButton')}
                </button>
              )}
              <button
                data-testid="submit-email"
                type="submit"
                onClick={buttonFunction}
                className={`Email__input--button ${userExists === false ? 'btnInverse' : ''}`}
              >
                {loadingAnim ? (
                  <span>
                    <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
                  </span>
                ) : (
                  buttonText
                )}

                {redirect.length > 0 && <Redirect to={redirect} />}
              </button>
              {userExists === false && (
                <Link to="/login/register">
                  <button type="button" className="Email__input--button">
                    {i18n.translate('loginScreen.version2.register')}
                  </button>
                </Link>
              )}
            </div>
            {userExists && (
              <span className="Email__input--forgotPassword">
                <span>{i18n.translate('loginScreen.version2.fields.forgotSubCopy')}</span>
                <Link to="/login/forgot">{i18n.translate('loginScreen.forgot')}</Link>
                <br />
                <br />
                <span> {i18n.translate('loginScreen.version2.fields.forgotSubCopy2')} </span>
                <Link to="/login/magic-link">{i18n.translate('loginScreen.version2.magicLinkButton')}</Link>
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

EmailInner.propTypes = {
  change: PropTypes.func.isRequired,
  checkInputValidity: PropTypes.func.isRequired,
  loadingAnim: PropTypes.bool.isRequired,
  salesCompanionAppId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setAnim: PropTypes.func.isRequired,
  userInput: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_state: PropTypes.string,
  }),
  userExists: PropTypes.bool,
  userExistsHandler: PropTypes.func.isRequired,
};

EmailInner.defaultProps = {
  salesCompanionAppId: undefined,
  userInput: {
    email: '',
    password: '',
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_state: '',
  },
  userExists: null,
};

export default function Email(props) {
  const { salesCompanionAppId } = useSettings();
  return <EmailInner {...props} salesCompanionAppId={salesCompanionAppId} />;
}

NoAgentScreen.propTypes = {
  clientName: PropTypes.string.isRequired,
  clientWebsite: PropTypes.string.isRequired,
};
